import React, { useState } from "react";

export default function MarathiInput({
  value = "",
  onChange = () => {},
  placeholder = "",
  label = "",
  name,
  error,
  maxLength,
  required,
  className = "",
}) {
  const [suggestions, setSuggestions] = useState([]);
  const [highlightIndex, setHighlightIndex] = useState(-1);

  const getTransliterationSuggestions = async (text) => {
    if (!text.trim()) {
      setSuggestions([]);
      return;
    }
    try {
      const res = await fetch(
        `https://inputtools.google.com/request?text=${encodeURIComponent(
          text
        )}&itc=mr-t-i0-und&num=5&cp=0&cs=1&ie=utf-8&oe=utf-8`
      );
      const data = await res.json();
      if (data[0] === "SUCCESS") {
        setSuggestions(data[1][0][1]);
        setHighlightIndex(-1);
      } else {
        setSuggestions([]);
      }
    } catch (err) {
      console.error("Transliteration error:", err);
    }
  };

  const handleChange = async (e) => {
    const val = e.target.value;
    onChange({ target: { name, value: val } });
    await getTransliterationSuggestions(val);
  };

  const applySuggestion = (s) => {
    onChange({ target: { name, value: s } });
    setSuggestions([]);
    setHighlightIndex(-1);
  };

  const handleKeyDown = (e) => {
    if (suggestions.length === 0) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightIndex((prev) =>
        prev < suggestions.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightIndex((prev) =>
        prev > 0 ? prev - 1 : suggestions.length - 1
      );
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightIndex >= 0 && highlightIndex < suggestions.length) {
        applySuggestion(suggestions[highlightIndex]);
      }
    } else if (e.key === "Escape") {
      setSuggestions([]);
    }
  };

  return (
    <div className="marathi-input-container" style={{ position: "relative" }}>
      {label && (
        <label className="my-1">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      <input
        type="text"
        name={name}
        value={value || ""}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className={`form-control ${className} ${error ? "is-invalid" : ""}`}
        maxLength={maxLength}
        autoComplete="off"
      />
      {error && (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {error}
        </div>
      )}
      {suggestions.length > 0 && (
        <ul
          className="suggestion-list shadow"
          style={{
            position: "absolute",
            zIndex: 1000,
            background: "#fff",
            width: "100%",
            borderRadius: "5px",
            listStyle: "none",
            margin: 0,
            padding: "5px 0",
          }}
        >
          {suggestions.map((s, i) => (
            <li
              key={i}
              onClick={() => applySuggestion(s)}
              style={{
                padding: "5px 10px",
                cursor: "pointer",
                background: i === highlightIndex ? "#f1f1f1" : "transparent",
              }}
            >
              {s}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
